type LogoProps = {
  className?: string;
  size?: number;
};

/**
 * Logo "Wniosek DoPlanu" — otwarta książka z pinezką mapy na górze.
 * SVG stylistycznie dopasowane do szarej palety interfejsu.
 * Kolor dziedziczony przez currentColor — steruj przez className text-*.
 */
function Logo({ className, size = 40 }: LogoProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Wniosek DoPlanu">
      {/* Podstawa — otwarta książka (dwa "skrzydła" stron) */}
      <path
        d="M4 32 L24 29 L44 32 L44 42 L24 39 L4 42 Z"
        fill="currentColor"
        fillOpacity="0.2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M24 29 L24 39" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />

      {/* Pinezka mapy */}
      <path
        d="M24 4 C18.2 4 13.5 8.7 13.5 14.5 C13.5 22 24 32 24 32 C24 32 34.5 22 34.5 14.5 C34.5 8.7 29.8 4 24 4 Z"
        fill="currentColor"
      />
      {/* "Oczko" pinezki */}
      <circle cx="24" cy="14.5" r="3.2" fill="#ffffff" />
    </svg>
  );
}

export default Logo;
